module.exports = __webpack_public_path__ + "img/slide04.d5731f4d.jpg";